export const GRAPH_ROW_TYPES = {
  USER: 'user',
  ORG: 'org',
}
